'use client';

import { WebSendVerificationCodeMutationResult } from '@/shared/types/types';
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
import { PhoneNumberInput } from './components/PhoneNumberInput';
import { PhoneNumberVerify } from './components/PhoneNumberVerify';

type Props = {
  sendVerificationCode: (p: { phoneNumber: string }) => Promise<WebSendVerificationCodeMutationResult>;
};

export function PhoneNumberLogin({ sendVerificationCode }: Props) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showVerify, setShowVerify] = useState(false);

  const router = useRouter();

  const handleClickBackButton = useCallback(() => {
    if (showVerify) {
      setShowVerify(false);
      return;
    }

    router.back();
  }, [showVerify, router]);

  const handleSubmitPhoneNumber = useCallback(async () => {
    await sendVerificationCode({ phoneNumber });
    setShowVerify(true);
  }, [phoneNumber, sendVerificationCode]);

  return (
    <>
      {showVerify ? (
        <PhoneNumberVerify phoneNumber={phoneNumber} onClickBackButton={handleClickBackButton} />
      ) : (
        <PhoneNumberInput phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} onSubmit={handleSubmitPhoneNumber} onClickBackButton={handleClickBackButton} />
      )}
    </>
  );
}
